"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArm64 = exports.isLinux = exports.isMacOS = exports.isWindows = void 0;
const tslib_1 = require("tslib");
const os = tslib_1.__importStar(require("os"));
function isWindows() {
    return os.type() === "Windows_NT";
}
exports.isWindows = isWindows;
function isMacOS() {
    return os.type() === "Darwin";
}
exports.isMacOS = isMacOS;
function isLinux() {
    return os.type() === "Linux";
}
exports.isLinux = isLinux;
function isArm64() {
    return os.arch() === "arm64";
}
exports.isArm64 = isArm64;
//# sourceMappingURL=system.js.map